// API Configuration for Admin Dashboard
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const api = {
  base: API_URL,
  
  // Auth
  auth: {
    login: `${API_URL}/auth/login`,
    profile: `${API_URL}/auth/profile`,
    getAllUsers: `${API_URL}/auth/users`,
    createUser: `${API_URL}/auth/users`,
    updateUser: (id: number) => `${API_URL}/auth/users/${id}`,
    deleteUser: (id: number) => `${API_URL}/auth/users/${id}`,
    changePassword: `${API_URL}/auth/change-password`,
    forgotPassword: `${API_URL}/auth/forgot-password`,
    resetPassword: `${API_URL}/auth/reset-password`,
  },
  
  // Announcements
  announcements: {
    getAll: (active?: boolean) => 
      `${API_URL}/announcements${active !== undefined ? `?active=${active}` : ''}`,
    getById: (id: number) => `${API_URL}/announcements/${id}`,
    create: `${API_URL}/announcements`,
    update: (id: number) => `${API_URL}/announcements/${id}`,
    delete: (id: number) => `${API_URL}/announcements/${id}`,
  },
  
  // Team
  team: {
    getAll: (active?: boolean) => 
      `${API_URL}/team${active !== undefined ? `?active=${active}` : ''}`,
    getById: (id: number) => `${API_URL}/team/${id}`,
    create: `${API_URL}/team`,
    update: (id: number) => `${API_URL}/team/${id}`,
    delete: (id: number) => `${API_URL}/team/${id}`,
  },
  
  // News / judgments drafts (n8n ingest + admin)
  drafts: {
    getAll: (opts?: { sourceName?: string; page?: number; limit?: number; q?: string; status?: string }) => {
      const params = new URLSearchParams();
      if (opts?.sourceName) params.append('sourceName', opts.sourceName);
      if (opts?.page) params.append('page', String(opts.page));
      if (opts?.limit) params.append('limit', String(opts.limit));
      if (opts?.q) params.append('q', opts.q);
      if (opts?.status) params.append('status', opts.status);
      const qs = params.toString();
      return `${API_URL}/admin/drafts${qs ? `?${qs}` : ''}`;
    },
    sources: `${API_URL}/admin/drafts/sources`,
    getById: (id: number) => `${API_URL}/admin/drafts/${id}`,
    delete: (id: number) => `${API_URL}/admin/drafts/${id}`,
    saveManual: (id: number) => `${API_URL}/admin/drafts/${id}/manual`,
    aiRewrite: (id: number) => `${API_URL}/admin/drafts/${id}/ai-rewrite`,
    translate: (id: number) => `${API_URL}/admin/drafts/${id}/translate`,
    publishOriginal: (id: number) => `${API_URL}/admin/drafts/${id}/publish-original`,
    publishEdited: (id: number) => `${API_URL}/admin/drafts/${id}/publish-edited`,
  },

  // Blog
  blog: {
    getAll: (published?: boolean, page?: number, limit?: number) => {
      const params = new URLSearchParams();
      if (published !== undefined) params.append('published', String(published));
      if (page) params.append('page', String(page));
      if (limit) params.append('limit', String(limit));
      return `${API_URL}/blog?${params.toString()}`;
    },
    getById: (id: number) => `${API_URL}/blog/${id}`,
    create: `${API_URL}/blog`,
    update: (id: number) => `${API_URL}/blog/${id}`,
    delete: (id: number) => `${API_URL}/blog/${id}`,
    addMedia: (id: number) => `${API_URL}/blog/${id}/media`,
    deleteMedia: (postId: number, mediaId: number) => `${API_URL}/blog/${postId}/media/${mediaId}`,
    reorderMedia: (id: number) => `${API_URL}/blog/${id}/media/reorder`,
  },
  
  // Consultations
  consultations: {
    getAll: (status?: string, page?: number, limit?: number) => {
      const params = new URLSearchParams();
      if (status) params.append('status', status);
      if (page) params.append('page', String(page));
      if (limit) params.append('limit', String(limit));
      return `${API_URL}/consultations?${params.toString()}`;
    },
    getById: (id: number) => `${API_URL}/consultations/${id}`,
    update: (id: number) => `${API_URL}/consultations/${id}`,
    delete: (id: number) => `${API_URL}/consultations/${id}`,
  },

  // Notifications (FCM)
  notifications: {
    register: `${API_URL}/notifications/register`,
  },

  // Locations (مواقع / Figma 13016-1963)
  locations: {
    getAll: (active?: boolean) =>
      `${API_URL}/locations${active !== undefined ? `?active=${active}` : ''}`,
    getById: (id: number) => `${API_URL}/locations/${id}`,
    create: `${API_URL}/locations`,
    update: (id: number) => `${API_URL}/locations/${id}`,
    delete: (id: number) => `${API_URL}/locations/${id}`,
  },
};

export default api;



